import { Button } from '@mui/material';
import { Link, useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const error = useRouteError() as any;

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center gap-4 text-left'>
      <h1>OPPs</h1>
      <p>This is titile when error</p>
      <p className='font-mono'>
        <span className='mr-2'>{error?.status}</span>
        <i>{error?.statusText || error?.message}</i>
      </p>
      <Button>
        <Link to='/' className='!text-white'>
          Back to home
        </Link>
      </Button>
    </div>
  );
}
